import BigTagButton from "../BigTagButton/BigTagButton.jsx";
import tagCloudStyles from "./TagCloud.css.ts";

const typeToLabel = {
  Video: "video",
  ExternalLink: "link",
  RichText: "artikel",
};

const TagCloud = ({
  validTags,
  tagFilter,
  toggleTag,
  validTypes,
  typeFilter,
  toggleType,
  validCategories,
  categoryFilter,
  toggleCategory,
  spark,
  sparkFilter,
  toggleSpark,
}) => {
  return (
    <div className={tagCloudStyles.TagCloud}>
      {[...validTags].map((tag) => (
        <BigTagButton
          key={`tag-${tag}`}
          active={tagFilter.has(tag)}
          onClick={() => toggleTag(tag)}
        >
          #{tag.toLowerCase()}
        </BigTagButton>
      ))}

      {[...validTypes].map((type) => (
        <BigTagButton
          key={`type-${type}`}
          active={typeFilter.has(type)}
          onClick={() => toggleType(type)}
        >
          #{typeToLabel[type]}
        </BigTagButton>
      ))}

      {[...validCategories].map((cat) => (
        <BigTagButton
          key={`cat-${cat}`}
          active={categoryFilter.has(cat)}
          onClick={() => toggleCategory(cat)}
        >
          #{cat.toLowerCase()}
        </BigTagButton>
      ))}

      <BigTagButton
        key={`cat-${spark.id}`}
        active={sparkFilter.has(spark.id)}
        onClick={() => toggleSpark(spark.id)}
      >
        #{spark.name}
      </BigTagButton>
    </div>
  );
};

export default TagCloud;
